export const MessagingTypes = {
  AUTOMATION: 'automation',
  CAMPAIGN: 'campaign',
};

export const BuilderTypes = {
  FLOW_BUILDER: 'flow-builder',
  LEGACY: 'legacy',
};

export const DashboardLog = {
  CARD_TYPE_ACQUISITION: 'acquisition',
  CARD_TYPE_REVENUE: 'revenue',
  CARD_TYPE_RETENTION: 'retention',
  CARD_TYPE_SLTV: 'sltv',
  CARD_TYPE_TOTAL_EARNED: 'total earned',
  CARD_TYPE_TOTAL_SUBSCRIBERS: 'total subscribers',
  CARD_TYPE_UNSUBSCRIBES: 'unsubscribes',
  LOCATION_AUTOMATIONS_SECTION: 'top performing automations section',
  LOCATION_CALENDAR_VIEW_DATE_LIST: 'calendar view date list',
  LOCATION_CAMPAIGNS_SECTION: 'top performing campaigns section',
  LOCATION_LIST_VIEW_EMPTY_STATE: 'list view empty state',
  LOCATION_MESSAGE_PLANNER_SECTION: 'planner section',
  LOCATION_SUBSCRIBER_SOURCES_SECTION:
    'top performing subscriber sources section',
  PLANNER_VIEW_CALENDAR: 'calendar',
  PLANNER_VIEW_LIST: 'list',
};
